export enum LocalStorageEnum {
    username = 'username',
    department_id = 'department_id',
    user_id = 'user_id',
    role = 'role',
    token = 'token',
    refresh_token = 'refresh_token',
    expiry_time = 'expiry_time',
    returned_ministry = 'returned_ministry',
    is_registered = 'is_registered',
    payment_status = 'payment_status',
    lang = 'lang',
    user = 'user',
    validate_data = 'validate_data',
    ent_id = 'ent_id',
    permissions = 'permissions'
}